import { Directive, inject } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from './dialog.service';
import { ComponentType } from '@angular/cdk/portal';
import { from, switchMap } from 'rxjs';

export type DialogConfig = Omit<MatDialogConfig, 'data'>;

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class AsyncDialog<Component, DataType, ReturnType = unknown> {
  protected dialog = inject(DialogService);

  abstract loadComponent(): Promise<ComponentType<Component>>;

  dialogConfig(): DialogConfig {
    return {};
  }

  async open(data?: DataType, config: DialogConfig = {}): Promise<MatDialogRef<Component, ReturnType>> {
    const component = await this.loadComponent();

    return this.dialog.openDialog(component, {
      ...this.dialogConfig(),
      ...config,
      data
    });
  }

  open$(data?: DataType, config: DialogConfig = {}) {
    return from(this.open(data, config)).pipe(switchMap((dialogRef) => dialogRef.afterClosed()));
  }
}
